import { CustomerErrorDetailsDtoCodeEnum } from '@/api/generated';

/**
 * The approval flow codes a customer update answers with: the edit tried to change the status of a
 * Prospekt or an Odrzucony klient (e.g. decided meanwhile), or the customer no longer exists.
 */
export const CUSTOMER_UPDATE_ERROR_CODES: readonly CustomerErrorDetailsDtoCodeEnum[] = [
  CustomerErrorDetailsDtoCodeEnum.CustomerNotFound,
  CustomerErrorDetailsDtoCodeEnum.CustomerStatusChangeNotAllowed,
];
